var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "head_svg__Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 779.57 998.94"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "head_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-40.21 3.83h978.78V1003.9H-40.21z"
  })), /*#__PURE__*/React.createElement("style", null, ".head_svg__cls-5{fill:none}.head_svg__cls-2{clip-path:url(#head_svg__clip-path)}.head_svg__cls-3{fill:#ecb989}.head_svg__cls-4{fill:#1d1d1b}.head_svg__cls-5{stroke:#ecb989;stroke-miterlimit:10;stroke-width:2px}.head_svg__cls-6{fill:#d0a278}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "head_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-3",
    d: "M124.48 584.55h419.46v483.61C543.94 1198.4 450 1304 334.21 1304s-209.73-105.6-209.73-235.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-3",
    d: "M516.59 884.27h-2zM599.4 59.1c0 20.71-64.23 37.5-143.47 37.5S312.47 79.81 312.47 59.1s64.23-37.5 143.46-37.5S599.4 38.39 599.4 59.1M777 669.33V305.46C777 138.88 642.59 3.83 476.8 3.83h-52.14c-165.79 0-300.18 135-300.18 301.63v184.82c0 217.27 175 393.45 391.16 394C633.6 883.73 777 787.72 777 669.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-3",
    d: "M236.34 551.77c0 64.65-52.17 117.08-116.52 117.08S3.3 616.42 3.3 551.77s52.16-117.08 116.52-117.08 116.52 52.42 116.52 117.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-4",
    d: "M97.14 501.83a73.1 73.1 0 0132.08 8c20 10.05 32.66 28.43 33.51 55.09l.05 2.89h-28c0-17.19-6.54-27-18.11-32.85a48.74 48.74 0 00-13.8-4.38 42.87 42.87 0 00-5.23-.61h-.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-5",
    d: "M97.14 501.83a73.1 73.1 0 0132.08 8c20 10.05 32.66 28.43 33.51 55.09l.05 2.89h-28c0-17.19-6.54-27-18.11-32.85a48.74 48.74 0 00-13.8-4.38 42.87 42.87 0 00-5.23-.61h-.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-6",
    d: "M180.24 692.9c17.12 104.62 60.34 182.41 147 213.21A245.34 245.34 0 00410 920.67q66 0 134-36.4h-27.41c-142.82 0-267.79-76.71-336.35-191.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-6",
    d: "M180.24 692.9c68.56 114.66 193.53 191.37 336.35 191.37h-4.86c-140.79-1.72-263.71-78-331.49-191.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-4",
    d: "M599.4 59.1c0 20.71-64.23 37.5-143.47 37.5S312.47 79.81 312.47 59.1s64.23-37.5 143.46-37.5S599.4 38.39 599.4 59.1m160.3 141.42C717.09 85.67 606.56 3.83 476.91 3.83h-52.37C258 3.83 123 138.87 123 305.45v129.24h106.4l10.33-234.17z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ecb989",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M545.41 399.19l27.68-5.13 40.21 217.21h-92.63v-28.15h58.79l-34.05-183.93z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "head_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-4",
    d: "M374.23 402c13.64 34.1 77 34.69 85.33 4.13l.39-1.66 27.6 5.52c-12.16 60.83-113.3 61.57-138.56 4.6l-.9-2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-5",
    d: "M374.23 402c13.64 34.1 77 34.69 85.33 4.13l.39-1.66 27.6 5.52c-12.16 60.83-113.3 61.57-138.56 4.6l-.9-2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-4",
    d: "M608.79 402c13.64 34.1 77 34.69 85.34 4.13l.39-1.66 27.6 5.52c-12.17 60.83-113.3 61.57-138.56 4.6l-.9-2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "head_svg__cls-5",
    d: "M608.79 402c13.64 34.1 77 34.69 85.34 4.13l.39-1.66 27.6 5.52c-12.17 60.83-113.3 61.57-138.56 4.6l-.9-2.14z"
  }))));
}
export default __webpack_public_path__ + "11872aaa0ee963c76bd1c701ae62768e.svg";
export { SvgHead as ReactComponent };